module.exports = __webpack_public_path__ + "static/media/pin (6).314c2ae3.png";